import { render } from "./partA.vue?vue&type=template&id=990906fa&scoped=true"
import script from "./partA.vue?vue&type=script&lang=js"
export * from "./partA.vue?vue&type=script&lang=js"

import "./partA.vue?vue&type=style&index=0&id=990906fa&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-990906fa"]])

export default __exports__